import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=2cae8d92"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=2cae8d92&prod&lang=scss"
import style1 from "./Detalhes.vue?vue&type=style&index=1&id=2cae8d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports